import { createAction } from 'redux-actions';
var actionKey = '@@topic';
export var watchTopic = createAction("".concat(actionKey, "/WATCH"), function (params, onSuccess) { return ({
    params: params,
    onSuccess: onSuccess,
}); });
export var watchTopicSuccess = createAction("".concat(actionKey, "/WATCH_SUCCESS"), function (params, response) { return ({
    params: params,
    response: response,
}); });
export var watchTopicFailure = createAction("".concat(actionKey, "/WATCH_FAILURE"), function (params) { return ({ params: params }); });
export var unwatchTopic = createAction("".concat(actionKey, "/UNWATCH"), function (params, onSuccess) { return ({
    params: params,
    onSuccess: onSuccess,
}); });
export var unwatchTopicSuccess = createAction("".concat(actionKey, "/UNWATCH_SUCCESS"), function (params, response) { return ({
    params: params,
    response: response,
}); });
export var unwatchTopicFailure = createAction("".concat(actionKey, "/UNWATCH_FAILURE"), function (params) { return ({ params: params }); });
export var suppressTopic = createAction("".concat(actionKey, "/SUPPRESS"), function (params, onSuccess) { return ({
    params: params,
    onSuccess: onSuccess,
}); });
export var suppressTopicSuccess = createAction("".concat(actionKey, "/SUPPRESS_SUCCESS"), function (params, response) { return ({
    params: params,
    response: response,
}); });
export var suppressTopicFailure = createAction("".concat(actionKey, "/SUPPRESS_FAILURE"), function (params) { return ({ params: params }); });
//# sourceMappingURL=actions.js.map